import { useUpdateUserMutation } from '../store/usersApi';

export const useUserBanEdit = () => {
  const [updateUser, { isLoading }] = useUpdateUserMutation();
  const banUser = async (id: number, isBanned: boolean) => {
    await updateUser({ id, isBanned });
  };
  return { banUser, banLoading: isLoading };
};
